/**
 * wagbappro.id 路由表（13 条）
 */
const DOMAIN = 'https://wagbappro.id';

function canonical(path) {
  return [{ rel: 'canonical', href: `${DOMAIN}${path}` }];
}

export default [
  {
    path: '/',
    name: 'home-id',
    component: () => import('@/views/wagbappro/home/index.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Unduh GB WhatsApp Terbaru 2026',
      title: 'WA GB Terbaru 2026 | Unduh GB WhatsApp APK v21.30 Anti-Ban',
      keywords: 'WA GB, Unduh WA GB APK',
      description:
        'Unduh WA GB APK v21.30 Anti-Ban terbaru 2026 untuk Android. Temukan fitur lengkap, panduan install, update, FAQ, dan tips menggunakan GB WhatsApp dengan mudah.',
      link: canonical('/'),
    },
  },
  {
    path: '/en/',
    name: 'home-en',
    component: () => import('@/views/wagbappro/home/en.vue'),
    meta: {
      locale: 'en',
      pageTitle: 'Download GB WhatsApp Latest 2026',
      title: 'Download GB WhatsApp APK v18.80 for Android – Free Anti-Ban',
      keywords: 'GB WhatsApp APK',
      description:
        'Download GB WhatsApp APK v18.80 for Android with anti-ban improvements, enhanced privacy features, custom themes, and dual account support. Free APK download with installation guide and update instructions.',
      link: canonical('/en/'),
    },
  },
  {
    path: '/unduh-gb-wa/',
    name: 'download-id',
    component: () => import('@/views/wagbappro/download/index.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Download WA GB APK v21.30 untuk Android',
      title: 'Download WA GB APK v21.30 untuk Android',
      keywords: 'WA GB, Unduh WA GB APK, GB WhatsApp download',
      description:
        'Download WA GB APK v21.30 untuk Android dengan fitur lengkap seperti privasi lebih fleksibel, tema kustom, dan GB WhatsApp anti ban. Versi terbaru ini mendukung Android 5.0+ dengan instalasi mudah melalui file APK.',
      link: canonical('/unduh-gb-wa/'),
    },
  },
  {
    path: '/unduh-gb-whatsapp-untuk-pc/',
    name: 'pc-id',
    component: () => import('@/views/wagbappro/pc/index.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Unduh GB WhatsApp untuk PC Versi Terbaru 2026',
      title: 'Unduh GB WhatsApp untuk PC Versi Terbaru 2026',
      keywords: 'GB WhatsApp PC, WA GB untuk PC',
      description:
        'Unduh GB WhatsApp untuk PC dan jalankan WA GB di komputer dengan emulator atau metode perangkat tertaut. Versi terbaru 2026, ringan dan mudah digunakan di Windows.',
      link: canonical('/unduh-gb-whatsapp-untuk-pc/'),
    },
  },
  {
    path: '/wa-gb-versi-lama/',
    name: 'old-versions-id',
    component: () => import('@/views/wagbappro/old-versions/index.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Unduh WA GB Versi Lama Gratis APK',
      title: 'Unduh WA GB Versi Lama Gratis APK – GB WhatsApp Semua Versi 2026',
      keywords: 'WA GB versi lama',
      description:
        'Unduh WA GB Versi Lama gratis dalam format APK dan akses semua versi GB WhatsApp. Dapatkan versi lama yang stabil, ringan, dan kompatibel untuk berbagai perangkat Android.',
      link: canonical('/wa-gb-versi-lama/'),
    },
  },
  {
    path: '/wa-gb-solusi-masalah/',
    name: 'blog-list-id',
    component: () => import('@/views/wagbappro/blog/list.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'WA GB Solusi Masalah Lengkap',
      title: 'WA GB Solusi Masalah Lengkap – Login, Error, Instal & Chat Issue',
      keywords: 'WA GB error, WA GB solusi masalah',
      description:
        'Kumpulan solusi masalah WA GB seperti tidak bisa login, gagal kirim pesan, error aplikasi, dan masalah instalasi APK. Semua panduan lengkap untuk membantu memperbaiki GB WhatsApp dengan cepat.',
      link: canonical('/wa-gb-solusi-masalah/'),
    },
  },
  {
    path: '/wa-gb-tidak-bisa-login/',
    name: 'blog-login',
    component: () => import('@/views/wagbappro/blog/post.vue'),
    meta: {
      locale: 'id',
      slug: 'login',
      pageTitle: 'Cara Mengatasi WA GB Tidak Bisa Login',
      title: 'Cara Mengatasi WA GB Tidak Bisa Login – Kenapa Saya Tidak Bisa Masuk WA GB?',
      keywords: 'WA GB tidak bisa login',
      description:
        'Panduan lengkap mengatasi WA GB tidak bisa login, gagal verifikasi, dan masalah masuk akun. Temukan penyebab utama dan solusi terbaru agar WA GB kembali normal.',
      link: canonical('/wa-gb-tidak-bisa-login/'),
    },
  },
  {
    path: '/wa-gb-tidak-bisa-mengirim-pesan/',
    name: 'blog-send-message',
    component: () => import('@/views/wagbappro/blog/post.vue'),
    meta: {
      locale: 'id',
      slug: 'send-message',
      pageTitle: 'WA GB Tidak Bisa Mengirim Pesan?',
      title: 'WA GB Tidak Bisa Mengirim Pesan? Kenapa Chat Saya Tidak Terkirim',
      keywords: 'WA GB tidak bisa kirim pesan',
      description:
        'Solusi lengkap jika WA GB tidak bisa mengirim pesan, chat hanya centang satu, atau gagal terkirim. Cek penyebab dan cara memperbaikinya dengan mudah.',
      link: canonical('/wa-gb-tidak-bisa-mengirim-pesan/'),
    },
  },
  {
    path: '/wa-gb-gagal-instal-apk/',
    name: 'blog-install-error',
    component: () => import('@/views/wagbappro/blog/post.vue'),
    meta: {
      locale: 'id',
      slug: 'install-error',
      pageTitle: 'Cara Mengatasi WA GB Gagal Instal / APK Tidak Bisa Dipasang',
      title: 'Cara Mengatasi WA GB Gagal Instal / APK Tidak Bisa Dipasang di Android',
      keywords: 'WA GB gagal instal',
      description:
        'Panduan mengatasi WA GB gagal instal, error APK, dan masalah pemasangan di Android. Solusi lengkap untuk memperbaiki install error dengan cepat.',
      link: canonical('/wa-gb-gagal-instal-apk/'),
    },
  },
  {
    path: '/disclaimer/',
    name: 'disclaimer-id',
    component: () => import('@/views/wagbappro/legal/disclaimer.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Disclaimer',
      title: 'Disclaimer',
      keywords: 'disclaimer, WAGBAPPRO.ID',
      description:
        'Baca disclaimer resmi WAGBAPPRO.ID mengenai informasi, konten, tautan pihak ketiga, dan penggunaan file APK yang tersedia di situs ini.',
      link: canonical('/disclaimer/'),
    },
  },
  {
    path: '/dmca/',
    name: 'dmca-id',
    component: () => import('@/views/wagbappro/legal/dmca.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'DMCA Policy',
      title: 'DMCA Policy',
      keywords: 'DMCA, WAGBAPPRO.ID',
      description:
        'Pelajari kebijakan DMCA WAGBAPPRO.ID serta prosedur pelaporan pelanggaran hak cipta dan permintaan penghapusan konten.',
      link: canonical('/dmca/'),
    },
  },
  {
    path: '/privacy-policy/',
    name: 'privacy-id',
    component: () => import('@/views/wagbappro/legal/privacy.vue'),
    meta: {
      locale: 'id',
      pageTitle: 'Privacy Policy',
      title: 'Privacy Policy',
      keywords: 'privacy policy, WAGBAPPRO.ID',
      description:
        'Pelajari bagaimana WAGBAPPRO.ID mengumpulkan, menggunakan, dan melindungi informasi pengguna saat mengakses situs ini.',
      link: canonical('/privacy-policy/'),
    },
  },
];
